export default __webpack_public_path__ + "static/media/Microsoft_Office_Excel_(2019–present).svg.34b7f3f5.png";